// src/contexts/caixas/CaixaResumoContext.js
import React, { createContext, useContext, useState } from 'react';
import { fetchData } from '../../services/Api.js';
import {CaixaResumo} from '../../models/caixas/CaixaResumo.js';

import { useMessage } from '../geral/MessageContext.js';

const CaixaResumoContext = createContext();

export const useCaixaResumo = () => useContext(CaixaResumoContext);

export const CaixaResumoProvider = ({ children }) => {    
    const [caixaResumoSel, setCaixaResumoSel] = useState(new CaixaResumo());      
    const { showMessage } = useMessage();

    const buscaCaixaResumo = async (id) => {
        try {
            if (!id) {
                setCaixaResumoSel(new CaixaResumo());
            } else {
                const result = await fetchData('/CaixaResumo/GetCaixaAberto', { caixaId: id });
                setCaixaResumoSel(result);
            }
            //showMessage('Resumo de caixa adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao buscar resumo de caixa:", error);
            showMessage('Erro ao buscar resumo de caixa', 'danger');
        }
    };

    return (
        <CaixaResumoContext.Provider value={{ caixaResumoSel, buscaCaixaResumo}}>
            {children}            
        </CaixaResumoContext.Provider>
    );
};
